import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve a stored image reference to a full URL. Absolute (http) URLs are
// returned as-is; locally stored images use a /api/files/... path.
export const mediaUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ml_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  // auth
  login: (body) => client.post("/auth/login", body).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data).catch(() => {}),
  // directory
  stats: () => client.get("/stats").then((r) => r.data),
  categories: () => client.get("/categories").then((r) => r.data),
  markets: () => client.get("/markets").then((r) => r.data),
  businesses: (params) => client.get("/businesses", { params }).then((r) => r.data),
  business: (id) => client.get(`/businesses/${id}`).then((r) => r.data),
  submitBusiness: (body) => client.post("/businesses", body).then((r) => r.data),
  track: (body) => client.post("/analytics/event", body).then((r) => r.data).catch(() => {}),
  // places
  places: (params) => client.get("/places", { params }).then((r) => r.data),
  // landing (SEO)
  landing: (city, category) =>
    client.get("/landing", { params: category ? { city, category } : { city } }).then((r) => r.data),
  landingIndex: () => client.get("/landing/index").then((r) => r.data),
  // newsletter
  subscribe: (body) => client.post("/newsletter/subscribe", body).then((r) => r.data),
  issues: () => client.get("/newsletter/issues").then((r) => r.data),
  // claims
  createClaim: (body) => client.post("/claims", body).then((r) => r.data),
  verifyClaim: (token) => client.get("/claims/verify", { params: { token } }).then((r) => r.data),
  editClaim: (body) => client.put("/claims/edit", body).then((r) => r.data),
  // payments
  plans: () => client.get("/payments/plans").then((r) => r.data),
  checkout: (body) => client.post("/payments/checkout", body).then((r) => r.data),
  paymentStatus: (sid) => client.get(`/payments/status/${sid}`).then((r) => r.data),
  // admin
  adminMetrics: () => client.get("/admin/metrics").then((r) => r.data),
  reviewQueue: (params) => client.get("/admin/review-queue", { params }).then((r) => r.data),
  approve: (id) => client.post(`/admin/review/${id}/approve`).then((r) => r.data),
  reject: (id, reason) => client.post(`/admin/review/${id}/reject`, { reason }).then((r) => r.data),
  audit: () => client.get("/admin/audit").then((r) => r.data),
  revert: (id) => client.post(`/admin/audit/${id}/revert`).then((r) => r.data),
  agentJobs: () => client.get("/admin/agent-jobs").then((r) => r.data),
  adminBusinesses: () => client.get("/admin/businesses").then((r) => r.data),
  toggleFeature: (id) => client.post(`/admin/businesses/${id}/feature`).then((r) => r.data),
  adminIssues: () => client.get("/admin/newsletter/issues").then((r) => r.data),
  sendIssue: (id) => client.post(`/admin/newsletter/issues/${id}/send`).then((r) => r.data),
  newsletterPreview: (id) => client.get(`/admin/newsletter/issues/${id}/preview`).then((r) => r.data),
  reviseIssue: (id, feedback) => client.post(`/admin/newsletter/issues/${id}/revise`, { feedback }).then((r) => r.data),
  deleteIssue: (id) => client.delete(`/admin/newsletter/issues/${id}`).then((r) => r.data),
  // agents
  agents: () => client.get("/agents").then((r) => r.data),
  agentActivity: (agent) => client.get(`/agents/${agent}/activity`).then((r) => r.data),
  runAgent: (agent, body) => client.post(`/agents/${agent}/run`, body || {}).then((r) => r.data),
  agentChat: (agent) => client.get(`/agents/${agent}/chat`).then((r) => r.data),
  sendAgentChat: (agent, message) => client.post(`/agents/${agent}/chat`, { message }).then((r) => r.data),
  executeAgentPlan: (agent) => client.post(`/agents/${agent}/chat/execute`).then((r) => r.data),
  resetAgentChat: (agent) => client.post(`/agents/${agent}/chat/reset`).then((r) => r.data),
};

export const CATEGORY_ICONS = {
  restaurantes: "utensils",
  panaderias: "croissant",
  barberias: "scissors",
  mecanicos: "wrench",
  tiendas: "shopping-bag",
  abogados: "scale",
  belleza: "sparkles",
  servicios: "briefcase",
};
